import { render } from "./UserMessage.vue?vue&type=template&id=18c44fcd&scoped=true"
import script from "./UserMessage.vue?vue&type=script&lang=js"
export * from "./UserMessage.vue?vue&type=script&lang=js"

import "./UserMessage.vue?vue&type=style&index=0&id=18c44fcd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c44fcd"]])

export default __exports__